import type { EpocusReview } from "$global-providers/rxdb-provider/collections/epocus-review";
import { SCORE_GOOD, SCORE_LOW, SCORE_OK } from "./qa-score-colors";

export const SELECTABLE_AGREEMENTS = [
  "agree",
  "minor_discrepancy",
  "major_discrepancy",
] as const;

export type SelectableAgreement = (typeof SELECTABLE_AGREEMENTS)[number];

export const AGREEMENT_LABELS: Record<EpocusReview["agreement"], string> = {
  agree: "Agree",
  minor_discrepancy: "Minor discrepancy",
  major_discrepancy: "Major discrepancy",
  disagree: "Disagree",
};

export const AGREEMENT_COLORS: Record<EpocusReview["agreement"], string> = {
  agree: SCORE_GOOD,
  minor_discrepancy: SCORE_OK,
  major_discrepancy: SCORE_LOW,
  disagree: SCORE_LOW,
};

export const isSelectableAgreement = (
  agreement: EpocusReview["agreement"],
): agreement is SelectableAgreement =>
  (SELECTABLE_AGREEMENTS as readonly string[]).includes(agreement);

export const isEscalating = (agreement: EpocusReview["agreement"]): boolean =>
  agreement === "major_discrepancy";

export const isAgreeingReview = (
  review: Pick<EpocusReview, "agreement">,
): boolean => review.agreement === "agree";
